<template>
  <div class="page-authorize d-flex justify-center align-center" style="height: calc(100vh - 24px);">
		<div>
			<v-card width="320" class="mx-auto">
				<v-card-text>
					<v-progress-circular
						class="mr-4"
						color="primary"
						indeterminate
						:size="24"
					></v-progress-circular>
					<span>Authorizing...</span>
				</v-card-text>
			</v-card>
		</div>
  </div>
</template>

<script>

export default {
	mounted() {
		if (this.$ravello.isAuth()) {
			this.$router.replace(this.$route.query.redirect_url || '/')
		} else {
			this.authorize()
		}
	},
	methods: {
		async authorize() {
			const { authorization_code: authorizationCode, redirect_url: to } = this.$route.query
			await this.$ravello.ssoAuthorize(authorizationCode)
			this.$router.replace(to || '/')
		},
	},
}
</script>
